import { render, staticRenderFns } from "./shiftBox.vue?vue&type=template&id=c159b3d6&"
import script from "./shiftBox.vue?vue&type=script&lang=js&"
export * from "./shiftBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports